const _ = require('lodash');
const Providers = require('./providers');
const GlobalProperties = require('./global_properties_attached_to_events');

function invokeAll(method, ...args) {
    for (const provider in Providers) {
        if (_.isFunction(Providers[provider][method])) {
            // check if function exists before call
            Providers[provider][method](...args);
        }
    }
}

function startSession(profile, options = {}) {
    invokeAll('startSession', profile, options);
}

function endSession(profile) {
    invokeAll('endSession', profile);
}

function trackEvent(event, metadata) {
    invokeAll(
        'trackEvent',
        event,
        Object.assign({}, metadata, GlobalProperties.items())
    );
}

module.exports = {
    startSession, // enabling interaction with intercom (chat, analytics) in localhost
    endSession, // enabling interaction with intercom (chat, analytics) in localhost
    trackEvent // enabling interaction with intercom (chat, analytics) in localhost
    // startSession: (Config.localhost ? (() => { }) : startSession),
    // endSession: (Config.localhost ? (() => { }) : endSession),
    // trackEvent: (Config.localhost ? (() => { }) : trackEvent)
};
